import { fonts } from '@opallabs/pulsar'

const postDimensions = {
  mobileSingle: { width: 375, height: 667 },
}

const renderDisplayLayout = {
  mobileSingle: {
    width: postDimensions.mobileSingle.width,
    height: postDimensions.mobileSingle.height,
  },
}

const baseStyles = (display) => ({
  backgroundColor: '#fff',
  borderRadius: '5px',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: fonts.proxima,
  ...renderDisplayLayout[display],
})

export { baseStyles }
